import React from 'react';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import '../common/CKEditorStyle.css';
import EditorWrapper from './EditorWrapper';

const styles = (theme) => ({
  wordCounter: {
    backgroundColor: 'rgb(249, 249, 249)',
    borderBottom: '1px solid #c4c4c4',
    borderLeft: '1px solid #c4c4c4',
    borderRight: '1px solid #c4c4c4',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px',
    textAlign: 'right',
    padding: '0.2em 1em',
    fontWeight: 'bold',
    fontSize: '11px',
    color: '#4c4c4c',
  },
});

class Editor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.data ? this.props.data : '',
    };
  }

  static getvedStateFromProps(props, state) {
    if (props.data !== state.content) {
      return { content: props.data };
    } else {
      return null;
    }
  }

  render() {
    return (
      <div>
        <EditorWrapper content={this.state.content} {...this.props} />
        <div className={this.props.classes.wordCounter} id="word-counter">
          Paragraphs: {this.props.paragraphCnt}, Words: {this.props.wordCnt}
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Editor));
